import { jsx as m } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
/* empty css              */
import { BASE_CLASS as t } from "./constants.js";
import s from "classnames";
const c = ({ children: r, classNames: o }) => /* @__PURE__ */ m("ul", { className: s(t, [o]), children: r });
export {
  c as BaseList
};
